import { Observable } from "rxjs/internal/Observable";
import { requestControlFletamento, requestOvVersionar } from "./request/ovPorVersionar.request";
import { controlFletamentoResponse, ovVersionarResponse } from "./response/ovPorVersionar.response";

export abstract class OvVersionarRepository{
    abstract listaOvVersionar( fd : requestOvVersionar):Observable<ovVersionarResponse>;
    abstract listaControlFletamento(fd: requestControlFletamento):Observable<controlFletamentoResponse>
}